window.Theme = window.Theme || {};
window.dataLayer = window.dataLayer || [];
const aa = window.algoliaShopify?.externals?.aa;
let confirmPopupTimeout;

document.body.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("swym-button") ||
    e.target.closest(".swym-button")
  ) {
    e.preventDefault();
  }
});

// Global function to initialize Swym buttons - can be called even before Swym loads
function initializeSwymButtons() {
  if (
    window._swat &&
    typeof window._swat.initializeActionButtons === "function"
  ) {
    window._swat.initializeActionButtons(".ais-hits-container");
    window._swat.initializeActionButtons(".swym-button");
    showIcons();
    return true; // Successfully initialized
  } else if (window.SwymCallbacks && Array.isArray(window.SwymCallbacks)) {
    // If Swym isn't loaded yet, wait for it
    window.SwymCallbacks.push(function (swat) {
      if (swat && typeof swat.initializeActionButtons === "function") {
        swat.initializeActionButtons(".ais-hits-container");
        swat.initializeActionButtons(".swym-button");
        showIcons();
      }
    });
    return false; // Will initialize when Swym loads
  }
  return false; // Swym not available
}

// Set up event listener immediately (not waiting for Swym to load)
document.addEventListener("swym:collections-loaded", function () {
  var initialized = initializeSwymButtons();
  // If Swym wasn't ready, retry after a short delay
  if (!initialized) {
    setTimeout(function () {
      initializeSwymButtons();
    }, 500);
    setTimeout(function () {
      initializeSwymButtons();
    }, 1500);
  }
});

// Also watch for new buttons being added to the DOM (for Algolia infinite scroll)
if (typeof MutationObserver !== "undefined") {
  var observer = new MutationObserver(function (mutations) {
    var hasNewButtons = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          if (node.classList && node.classList.contains("swym-button")) {
            hasNewButtons = true;
          } else if (node.querySelector && node.querySelector(".swym-button")) {
            hasNewButtons = true;
          }
        }
      });
    });
    if (hasNewButtons) {
      initializeSwymButtons();
    }
  });

  // Start observing when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      var container = document.querySelector(".ais-hits-container");
      if (container) {
        observer.observe(container, { childList: true, subtree: true });
      }
    });
  } else {
    var container = document.querySelector(".ais-hits-container");
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }
  }
}

function swymCallbackFn(swat) {
  // Swym event listeners
  // Product added to wishlist/favourites
  swat.evtLayer.addEventListener(
    swat.JSEvents.addedToWishlist,
    function (event) {
      showCustomNotification(event);
      sendAlgoliaEvent(event);
      sendGAEvent(event);
      sendDYEvent(event);
      setTimeout(function () {
        refreshFavouritesDropdown();
      }, 2000);
    }
  );

  // Product removed to wishlist/favourites
  swat.evtLayer.addEventListener(
    swat.JSEvents.removedFromWishlist,
    function (event) {
      showCustomNotification(event);
      refreshFavouritesDropdown();
      sendAlgoliaEvent(event);
      sendGAEvent(event);
      sendDYEvent(event);
    }
  );

  // Initialize on quickview open
  document.addEventListener("quickview:open", function () {
    if (swat && typeof swat.initializeActionButtons === "function") {
      swat.initializeActionButtons(".qv-add-to-cart__add-to-favourites");
    }
  });

  // Initialize on variant change
  document.addEventListener("swym:variant-changed", function () {
    if (swat && typeof swat.initializeActionButtons === "function") {
      swat.initializeActionButtons(".pdp_add-to-favourites");
    }
  });

  // Initialize buttons that are already on the page
  if (typeof swat.initializeActionButtons === "function") {
    swat.initializeActionButtons();
  }
  showIcons();
  refreshFavouritesDropdown();
}

function sendGAEvent(event) {
  const product = event.detail.d;
  const eventAction = event.type === "sw:addedtowishlist" ? "ADDED" : "REMOVED";
  const page = window.location.pathname.startsWith("/products/")
    ? "PDP"
    : "PLP";

  window.dataLayer.push({
    event: `${page}-${eventAction}-WISHLIST`,
    action: `${page}-${eventAction}-WISHLIST`,
    category: "wishlist",
    label: product.dt,
  });
}

function sendDYEvent(event) {
  if (!Theme.settings.dynamic_yield_enabled) return;
  const product = event.detail.d;
  const eventAction = event.type === "sw:addedtowishlist" ? "ADDED" : "REMOVED";
  const page = window.location.pathname.startsWith("/products/")
    ? "PDP"
    : "PLP";

  DY.API("event", {
    name: `${page}-${eventAction}-WISHLIST`,
    properties: {
      product: {
        title: product.dt,
        price: product.pr,
        sku: product.sku,
        productId: product.sku,
        variant: product.vi,
        size: product.vi.split("/").pop(),
        currency: product.cu,
      },
    },
  });
}

function sendAlgoliaEvent(event) {
  if (
    !Theme.settings.algolia_enabled ||
    !window.algoliaShopify?.config?.analytics_enabled ||
    !aa
  ) {
    return;
  }

  const action =
    event.type === "sw:addedtowishlist" ? "Added to" : "Removed from";
  const variantId = String(event.detail.d.epi);
  const userToken = window.Theme.settings.algolia.userToken;

  if (window.location.pathname.startsWith("/products/")) {
    // PDP
    const userToken = localStorage.getItem("algolia_user_token");
    let prevClick, queryId;
    try {
      prevClick = JSON.parse(
        localStorage.getItem("algolia_analytics_clicked_objects")
      );
      prevClick = prevClick.find(
        (data) => data.productId == event.detail.d.empi
      );
      queryId = prevClick?.queryID;
    } catch (err) {}

    try {
      if (queryId && userToken) {
        aa.convertedObjectIDsAfterSearch({
          userToken: userToken,
          eventName: `PDP: ${action} Wishlist`,
          index: window.Theme.settings.algolia.product_index,
          objectIDs: [variantId],
          queryID: queryId,
        });
      } else if (userToken && variantId) {
        aa.convertedObjectIDs({
          userToken: userToken,
          eventName: `PDP: ${action} Wishlist`,
          index: window.Theme.settings.algolia.product_index,
          objectIDs: [variantId],
        });
      }
    } catch (err) {
      console.error(err);
    }
  } else {
    // PLP
    const product =
      document.querySelector(
        '[data-product-id="' + event.detail.d.empi + '"]'
      ) || {};
    const { queryId, objectId } = product?.dataset;

    try {
      if (queryId && userToken) {
        aa.convertedObjectIDsAfterSearch({
          userToken: userToken,
          eventName: `PLP: ${action} Wishlist`,
          index: window.Theme.settings.algolia.product_index,
          objectIDs: [objectId],
          queryID: queryId,
        });
      } else if (userToken && variantId) {
        aa.convertedObjectIDs({
          userToken: userToken,
          eventName: `PLP: ${action} Wishlist`,
          index: window.Theme.settings.algolia.product_index,
          objectIDs: [variantId],
        });
      }
    } catch (err) {
      console.error(err);
    }
  }
}

function showIcons() {
  var icons = document.querySelectorAll(".swym-ais-button");
  icons.forEach((i) => {
    i.style.visibility = "visible";
  });
}

// Swym custom notification popup
async function showCustomNotification(event) {
  const parentContainer = document.querySelectorAll(
    ".swym-custom-notify-container"
  );
  let product = event.detail.d;

  if (parentContainer.length) {
    product = SwymUtils.formatProductPrice(product);
    product.variantInfo = getVariantInfo(product.variants);
    if (!product.iu || !product.dt) {
      const p = await Theme.graphQL(`{
        product(id: "gid://shopify/Product/${product.empi}") {
          title
          featuredImage {
            url(transform: { maxWidth: 80 })
          }
        }
      }`);
      product.iu = p.data?.product.featuredImage.url;
      product.dt = p.data?.product.title;
    }

    const notificationDetails = SwymUtils.renderTemplateString(
      notificationMarkup(
        event.type === "sw:addedtowishlist" ? "Added To" : "Removed From"
      ),
      product
    );

    [].forEach.call(parentContainer, function (parentContainer) {
      parentContainer.innerHTML = notificationDetails;
    });

    document.body.classList.add("favourite-added");

    // Clear notification after 5 seconds
    if (confirmPopupTimeout) {
      clearTimeout(confirmPopupTimeout);
    }

    confirmPopupTimeout = setTimeout(function () {
      document.body.classList.remove("favourite-added");
      document.body.classList.remove("swym-modal-active");
    }, 5000);
  }
}

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]" ? Object.keys(variants[0]) : [],
      variantinfo;
    if (variantKeys.length) {
      variantinfo = variantKeys[0];
    }
    return variantinfo == "Default Title" ? "" : variantinfo;
  } catch (err) {
    return variants;
  }
}

function notificationMarkup(action) {
  var __notificationMarkup = `
    <div class="swym-custom-notify-container-inner">
      <div class="swym-custom-notify-title">${action} Favourites</div>
      <div class="swym-custom-notify-body">
        <img src="{{iu}}" loading="lazy">
        <div class="swym-custom-notify-content">{{dt}}</div>
      </div>
      <a class="btn" href="/pages/favourites">View Your Favourites</a>
      ${
        !Theme.customer.id
          ? `<a class="swym-custom-notify-login-link" href="/account/login" data-modal-login>Sign In To Save And Share</a>`
          : ""
      }
    </div>`;
  return __notificationMarkup;
}

function refreshFavouritesDropdown() {
  document.querySelector("[data-quick-favourites-products]").innerHTML = "";

  window._swat.fetch(function (products) {
    refreshFavouritesCount(products);
    if (products.length == 0) {
      document
        .querySelector("[data-quick-favourites]")
        .classList.remove("quick-favourites--enabled");
      return products;
    } else {
      document
        .querySelector("[data-quick-favourites]")
        .classList.add("quick-favourites--enabled");
    }

    buildFavouritesDropdown(products);
  });
}

function refreshFavouritesCount(products) {
  document
    .querySelectorAll("[data-header-favourites-count]")
    .forEach((node, index) => {
      node.innerHTML = products.length;

      if (products.length == 0) {
        node.style.display = "none";
      } else {
        node.style.display = "flex";
      }
    });
}

function buildFavouritesDropdown(products) {
  products.forEach((product, index) => {
    var productUrl = product.du.match(/\/products\/.+/);

    if (productUrl && productUrl[0]) {
      productUrl += ".js";
      // Get product details
      fetch(productUrl)
        .then((res) => res.json())
        .then((p) => {
          // Extract in stock variants
          var inStockVariants = p.tags.join(",").match(/In_Stock.*?(?=\|)/gim);
          inStockVariants =
            inStockVariants?.length > 0
              ? inStockVariants.map((v) => parseInt(v.split(":")[1]))
              : [];
          let variantInStock = false;
          p.variants.forEach((v) => {
            if (inStockVariants.includes(v.id)) {
              if (product.epi == v.id) {
                var price = document.querySelector(
                  '.quick-favourites__product[data-product-id="' +
                    product.empi +
                    '"][data-variant-id="' +
                    product.epi +
                    '"] [data-original-price]'
                );
                // Update the price if it's on sale
                if (v.compare_at_price && v.compare_at_price != v.price) {
                  price.innerHTML = `<span class="sale-price">$${(
                    v.price / 100
                  ).toFixed(2)}</span><s>$${(v.compare_at_price / 100).toFixed(
                    2
                  )}</s>`;
                } else {
                  price.innerHTML = `$${(v.price / 100).toFixed(2)}`;
                }
              }
            }

            // They have added a variant that is not in stock, but still update the price if it's on sale
            if (!variantInStock && product.epi == v.id) {
              var price = document.querySelector(
                '.quick-favourites__product[data-product-id="' +
                  product.empi +
                  '"][data-variant-id="' +
                  product.epi +
                  '"] [data-original-price]'
              );
              if (v.compare_at_price && v.compare_at_price != v.price) {
                price.innerHTML = `<span class="sale-price">$${(
                  v.price / 100
                ).toFixed(2)}</span><s>$${(v.compare_at_price / 100).toFixed(
                  2
                )}</s>`;
              } else {
                price.innerHTML = `$${(v.price / 100).toFixed(2)}`;
              }
            }
          });
        })
        .catch((err) => console.error("Unable to fetch product", err));
    }

    const div = document.createElement("div");
    div.classList.add("quick-favourites__product");
    div.dataset.variantId = product.epi;
    div.dataset.productId = product.empi;
    div.innerHTML = `<div class="quick-favourites__product-image">
          <a class="naked-link" href="${product.du}">
            <img src="${product.iu}" alt="${product.dt}" />
          </a>
        </div>
        <div class="quick-favourites__product-details">
          <a class="hover-link quick-favourites__product-link" href="${product.du}">${product.dt}</a>
          <span class="quick-favourites__product-price product-price" data-original-price="${product.empi}">$${product.pr}</span>
          <div class="quick-favourites__product-options">
          </div>
        </div>`;

    document.querySelector("[data-quick-favourites-products]").append(div);
  });
}

// Ensure window.SwymCallbacks is properly initialized
// Use the protected getter if it exists, otherwise create array
if (!window.SwymCallbacks || !Array.isArray(window.SwymCallbacks)) {
  if (
    typeof Object.getOwnPropertyDescriptor === "function" &&
    Object.getOwnPropertyDescriptor(window, "SwymCallbacks")
  ) {
    // Property is protected, use getter
    window.SwymCallbacks = window.SwymCallbacks || [];
  } else {
    window.SwymCallbacks = [];
  }
}

// Push your callback function into SwymCallbacks
if (Array.isArray(window.SwymCallbacks)) {
  window.SwymCallbacks.push(swymCallbackFn);
}
